import { combineReducers } from 'redux';

import data from './data';

/**
 * @typedef {{
 *   data: import('./data').DealerConfigurationGeneralByIdReducer,
 * }} DealerConfigurationGeneralReducer
 */

export default combineReducers({
  data,
});
